var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-3" },
    [
      _vm.attributes.length ||
      (_vm.possibleUnitCombinationIds.length > 1 && _vm.isContentVisible)
        ? [
            _vm._l(_vm.attributes, function (attribute, index) {
              return _c(
                "div",
                { key: index, staticClass: "variation-select" },
                [
                  attribute.type === "dropdown"
                    ? _c(
                        "div",
                        {
                          ref: "dropdownContainer",
                          refInFor: true,
                          staticClass: "custom-dropdown",
                        },
                        [
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.isTextCut(attribute.name),
                                  expression: "isTextCut(attribute.name)",
                                },
                              ],
                              attrs: {
                                for: "custom-select_" + attribute.name,
                                "data-toggle": "tooltip",
                                "data-placement": "top",
                                title: attribute.name,
                                "data-testing":
                                  "variation-select-dropdown-label",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(attribute.name) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "custom-select mt-2",
                              attrs: { id: "custom-select_" + attribute.name },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "small",
                                  on: {
                                    click: function ($event) {
                                      _vm.selectOptionActive =
                                        !_vm.selectOptionActive
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ]
                                          ? _vm.getSelectedAttributeValueName(
                                              attribute
                                            )
                                          : _vm.$translate(
                                              "Ceres::Template.singleItemPleaseSelect"
                                            )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.selectOptionActive
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-dropdown-list position-absolute w-100 bg-white",
                                    },
                                    _vm._l(attribute.values, function (value) {
                                      return _c(
                                        "div",
                                        {
                                          key: value.attributeValueId,
                                          attrs: {
                                            value: value.attributeValueId,
                                            selected:
                                              value.attributeValueId ===
                                              _vm.selectedAttributes[
                                                attribute.attributeId
                                              ],
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.selectAttribute(
                                                attribute.attributeId,
                                                value.attributeValueId
                                              )
                                              _vm.selectOptionActive = false
                                            },
                                          },
                                        },
                                        [
                                          value.attributeValueId !==
                                          _vm.selectedAttributes[
                                            attribute.attributeId
                                          ]
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "p-2 custom-dropdown-item d-flex justify-content-between align-items-center",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex justify-content-between w-100",
                                                        class: {
                                                          "flex-column":
                                                            value.defaultPrice &&
                                                            value.rrpPrice,
                                                          "w-100": !(
                                                            value.defaultPrice &&
                                                            value.rrpPrice
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                value.name
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          [
                                                            _vm.isAttributeSelectionValid(
                                                              attribute.attributeId,
                                                              value.attributeValueId,
                                                              true
                                                            )
                                                              ? [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-sucess",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                          " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .multiLanguage
                                                                              .ProductInstock
                                                                          ) +
                                                                          "\n                        "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-muted",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                          " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .multiLanguage
                                                                              .ProductOutOfStock
                                                                          ) +
                                                                          "\n                        "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    value.defaultPrice &&
                                                    value.rrpPrice
                                                      ? _c("p", {
                                                          staticClass:
                                                            "d-flex font-weight-medium",
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-primary text-nowrap",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "currency"
                                                              )(
                                                                value.isNet
                                                                  ? value
                                                                      .defaultPrice
                                                                      .data
                                                                      .unitPriceNet
                                                                  : value
                                                                      .defaultPrice
                                                                      .data
                                                                      .unitPrice
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "del",
                                                      {
                                                        staticClass:
                                                          "ml-2 text-nowrap",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "currency"
                                                              )(
                                                                value.isNet
                                                                  ? value
                                                                      .rrpPrice
                                                                      .data
                                                                      .unitPriceNet
                                                                  : value
                                                                      .rrpPrice
                                                                      .data
                                                                      .unitPrice
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p"),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    : attribute.type === "box" || attribute.type === "image"
                    ? _c("div", [
                        _c(
                          "span",
                          {
                            staticClass: "text-muted",
                            attrs: { "data-testing": "attribute-name" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(attribute.name) +
                                ":\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "font-weight-bold",
                            attrs: { "data-testing": "attribute-value" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.getSelectedAttributeValueName(attribute)
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "v-s-boxes pb-1 mt-2 mb-3 mx-0 images",
                            class: { images: attribute.type === "image" },
                          },
                          [
                            _vm.addPleaseSelectOption
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "v-s-box bg-white empty-option",
                                    class: {
                                      active:
                                        _vm.selectedAttributes[
                                          attribute.attributeId
                                        ] === -1,
                                      "d-none": !_vm.isAttributeSelectionValid(
                                        attribute.attributeId,
                                        -1
                                      ),
                                    },
                                    attrs: {
                                      "data-testing": "variation-select-box",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectAttribute(
                                          attribute.attributeId,
                                          -1
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "mx-3" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemPleaseSelect"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(attribute.values, function (value) {
                              return [
                                value.imageUrl
                                  ? _c(
                                      "div",
                                      {
                                        key: value.attributeValueId,
                                        staticClass: "v-s-box bg-white",
                                        class: {
                                          active:
                                            value.attributeValueId ===
                                            _vm.selectedAttributes[
                                              attribute.attributeId
                                            ],
                                          invalid:
                                            !_vm.isAttributeSelectionValid(
                                              attribute.attributeId,
                                              value.attributeValueId,
                                              true
                                            ),
                                        },
                                        attrs: {
                                          "data-testing":
                                            "variation-select-box",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectAttribute(
                                              attribute.attributeId,
                                              value.attributeValueId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        attribute.type === "box"
                                          ? _c(
                                              "span",
                                              { staticClass: "mx-3" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(value.name) +
                                                    "\n              "
                                                ),
                                              ]
                                            )
                                          : _c("img", {
                                              staticClass: "p-1",
                                              attrs: {
                                                src: value.imageUrl,
                                                alt: value.name,
                                                title: value.name,
                                                loading: "lazy",
                                                decoding: "async",
                                              },
                                            }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            _vm._v(" "),
            _vm.possibleUnitCombinationIds.length > 1 && _vm.isContentVisible
              ? _c("div", { staticClass: "variation-select" }, [
                  _c("div", { staticClass: "input-unit" }, [
                    _c(
                      "select",
                      {
                        staticClass: "custom-select",
                        attrs: {
                          id: "unit-combination-ids-select",
                          "data-testing": "variation-select-unit",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.selectUnit($event.target.value)
                          },
                        },
                      },
                      _vm._l(
                        _vm.possibleUnitCombinationIds,
                        function (unitCombinationId) {
                          return _c(
                            "option",
                            {
                              key: unitCombinationId,
                              domProps: {
                                value: unitCombinationId,
                                selected:
                                  parseInt(unitCombinationId) ===
                                  _vm.selectedUnit,
                              },
                            },
                            [
                              _vm.isUnitSelectionValid(unitCombinationId)
                                ? [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.possibleUnits[unitCombinationId]
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemInvalidAttribute",
                                            {
                                              name: _vm.possibleUnits[
                                                unitCombinationId
                                              ],
                                            }
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ],
                            ],
                            2
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: {
                          for: "unit-combination-ids-select",
                          "data-testing": "variation-select-unit-label",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.singleItemContent"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]
        : [_vm._t("default")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }